import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

const EXIT_MS = 280;

export function usePageTransition(delay = 400, { home = false } = {}) {
  const location = useLocation();
  const [phase, setPhase] = useState("loading");

  useEffect(() => {
    setPhase("loading");
    const exitTimer = setTimeout(() => setPhase("exiting"), delay);
    const readyTimer = setTimeout(() => setPhase("ready"), delay + EXIT_MS);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(readyTimer);
    };
  }, [delay, home, location.pathname]);

  return {
    phase,
    showSkeleton: phase === "loading" || phase === "exiting",
    showContent: phase === "exiting" || phase === "ready",
    isExiting: phase === "exiting",
    isReady: phase === "ready",
  };
}
